/* eslint-disable import/no-default-export */
import {CartController} from './CartController';
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk';

export default controllerFactory(CartController, {shouldCallAppSettingsOnlyWhenMultilingualIsNeeded: true});
